import { useState, useCallback, useRef, useContext, useEffect } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { ServiceContext } from "../../../contexts/ServiceContext";
import { ReactComponent as PhoneNumberIcon } from "../../../icons/phone-number.svg";
import { ReactComponent as DescriptionIcon } from "../../../icons/description.svg";
import { ReactComponent as CompanyIcon } from "../../../icons/company.svg";
import { ReactComponent as EmailIcon } from "../../../icons/email.svg";
import { ReactComponent as RoleIcon } from "../../../icons/role.svg";
import { ReactComponent as EditIcon } from "../../../icons/edit.svg";
import { ReactComponent as DeleteIcon } from "../../../icons/delete.svg";
import { ReactComponent as MenuIcon } from "../../../icons/menu.svg";
import { ReactComponent as EmailsMenuIcon } from "../../../icons/email-menu.svg";
import { ReactComponent as DevicesMenuIcon } from "../../../icons/devices-menu.svg";
import { ReactComponent as UsersMenuIcon } from "../../../icons/users-menu.svg";
import { ReactComponent as CompaniesMenuIcon } from "../../../icons/company-menu.svg";
import { ReactComponent as MessagesMenuIcon } from "../../../icons/messages-menu.svg";
import { ReactComponent as PhoneNumberMenuIcon } from "../../../icons/phone-number-menu.svg";
import { AppAlert } from "../../../utils/AppAlert";
import { ApiError } from "../../../services/ApiError";
import Select from "react-select";
import config from "../../../config";
import './users.css';

function Users () {
  const [open, setOpen] = useState(true);
  const [users, setUsers] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedItemId, setSelectedItemId] = useState(0);
  const [searchParams, setSearchParams] = useSearchParams();
  const {infrastructureService} = useContext(ServiceContext);
  const [availableCompanies, setAvailableCompanies] = useState("");
  const [availableUsers, setAvailableUsers] = useState("");
  const [availableDevices, setAvailableDevices] = useState("");
  const [emailNotifications, setAvailableEmailNotifications] = useState("");
  const [messagesNotifications, setAvailablemMssagesNotifications] = useState("");
  const [phoneCallsNotifications, setAvailablePhoneCallsNotifications] = useState("");
  const [filter, setFilter] = useState(searchParams.get("filter") || "");
  const [companyId, setCompanyId] = useState(searchParams.get("companyId") || ""); 
  const [menu, setMenu] = useState(null);
  const menuRef = useRef(null);
  const userRole = localStorage.getItem("user_role");
  const [currentPage, setCurrentPage] = useState(Number(searchParams.get("currentPage")) || 1);
  const [totalPages, setTotalPages] = useState(1);
  const Global_Admin_Role = "Global Admin";
  let updatedIds;
  const itemsPerPage = config.uiSettings.itemsPerPage || 20;

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      backgroundColor: "#f5f5f5",
      borderColor: state.isFocused ? "#c7c4c4ff" : "#ccc",
      boxShadow: state.isFocused ? "0 0 0 2px #b1aeaeff" : "none",
      "&:hover": { borderColor: "#3f3f3fff" },
      borderRadius: "8px",
      padding: "2px 4px",
      minHeight: "42px",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#525050"
        : state.isFocused
        ? "#ebe8e8ff"
        : "white",
      color: state.isSelected ? "white" : "#525050",
      padding: "10px 15px",
      cursor: "pointer",
      fontWeight: state.isSelected ? "bold" : "normal",
      transition: "background-color 0.1s ease",
      ":active": {
        backgroundColor: "#525050",
        color : "white"
      }
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#888",
      fontStyle: "italic"
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#222"
    }),
    dropdownIndicator: (provided, state) => ({
      ...provided,
      color: state.isFocused ? "#3f3f3fff" : "#999",
      "&:hover": { color: "#3f3f3fff" }
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: "8px",
      overflow: "hidden",
      marginTop: "4px",
      boxShadow: "0 4px 12px #525050"
    }),
    menuList: (provided) => ({
      ...provided,
      padding: 0
    })
  }; 

  const navigate = useNavigate();   

  const handleLeftClick = (e, id) => {
    e.stopPropagation();

    const clickX = e.clientX;
    const clickY = e.clientY;
    const screenW = window.innerWidth;
    const screenH = window.innerHeight;

    const menuW = 120; 
    const menuH = menuRef.current ? menuRef.current.offsetHeight : 120;

    let posX = clickX;
    let posY = clickY;
    
    if (clickX + menuW > screenW) {
      posX = screenW - menuW - 5;
    }
    
    if (clickY + menuH > screenH) {
      posY = screenH - menuH - 5;
    }

    setMenu({ x: posX, y: posY, id });
  };
  
  
  function navigateToUserSettingsClick(id) {
    navigate("/user/" + id);
  } 
  
  const handlePageChange = (p) => {
    setCurrentPage(p);
    setSearchParams({ids: (updatedIds || []).join(","),  companyId: companyId, filter: filter, currentPage: p});
  };

  const handleChange = (e) => {
    setCurrentPage(1);
    setFilter(e.target.value);
    setSearchParams({ids: (updatedIds || []).join(","), companyId: companyId, filter: e.target.value, currentPage: 1});
  };
  
  const handleBlur = (e) => {
    setSearchParams({ids: (updatedIds || []).join(","), companyId: companyId, filter: e.target.value, currentPage: 1});
  };

  const handleCompanyChange = (selectedOption) => {
    setCurrentPage(1);
    if (selectedOption.value === "all") {
      setCompanyId("");
      setSearchParams({ids: (updatedIds || []).join(","), companyId: "", filter: filter, currentPage: 1});
    } else {
      setCompanyId(selectedOption?.value || null);
      setSearchParams({ids: (updatedIds || []).join(","), companyId: selectedOption?.value || null, filter: filter, currentPage: 1});
    }
  };
    
  function deleteUserClick() {
    setIsOpen(true);
  }

  function User({id, email, phoneNumber, firstName, lastName, companyid, roles }) {
    
    const [openExpanderCard, setOpenExpanderCard] = useState(false);
    
    useEffect(() => {
         const idsFromUrl = (searchParams.get("ids") || "").split(",").filter(Boolean).map(String);
         setOpenExpanderCard(idsFromUrl.includes(email));
    }, [email]);
    
    const toggleCard = () => {
        const idsFromUrl = (searchParams.get("ids") || "").split(",").filter(Boolean).map(String);   
        if (idsFromUrl.includes(email)) {
             updatedIds = idsFromUrl.filter(i => i !== email);
        } else {
             updatedIds = [...idsFromUrl, email];
        }
        setSearchParams({ ...Object.fromEntries(searchParams.entries()), ids: (updatedIds || []).join(","), companyId: companyId, filter: filter, currentPage: currentPage });
    };
  
    return (
      <div className="card-border">
        <div className="card-div" onClick={toggleCard} >
          <div className="div-inline-50">
            {`${firstName ?? ""} ${lastName ?? ""}`.trim() || "No name"}
          </div>
          <div className="div-inline-20">
            <label></label>
          </div>
          <div className="div-inline-20">
            <label></label>
          </div>
          <div className="div-inline-3"></div>
        <div className="div-inline-3">
          <svg  width="20" height="20" fill="currentColor" viewBox="0 0 16 16" onClick={(e) => handleLeftClick(e, id)}>
            <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"/>
          </svg>
          {menu && menu.id === id && (
            <ul ref={menuRef} className="context-menu" style={{ top: menu.y, left: menu.x, position: "fixed" }}>
              <li onClick={(e) => {  e.stopPropagation(); navigateToUserSettingsClick(id);}}>
                <label>
                  <EditIcon/> Edit
                </label>
              </li>
              <li>
                <label onClick={(e) => {  e.stopPropagation(); setSelectedItemId(id); deleteUserClick(); setMenu(null);}}>
                  <DeleteIcon/> Delete
                </label>                
              </li>
            </ul>
          )}
        </div>
          <div className="div-inline-3">
            <div className="open-expander-card">
                {openExpanderCard ? "▲" : "▼"}
            </div>
          </div>
        </div>
        <div className="cerd-div">
          {openExpanderCard && (
             <div className="card-div card-border-text">
                <div className="div-inline-100">
                  <label>
                    <DescriptionIcon/><span className="span-bold">First name</span><span>: {firstName || "—"}</span>
                   </label><br/>
                   <label>
                    <DescriptionIcon/><span className="span-bold">Last name</span><span>: {lastName || "—"}</span>
                   </label><br/>
                   <label>
                    <EmailIcon/><span className="span-bold">Email</span><span>: {email}</span>
                   </label><br/>
                   <label>
                      <PhoneNumberIcon/><span className="span-bold">Phone number</span><span>: {phoneNumber || "—"}</span>
                   </label><br/>
                   <label>
                     <CompanyIcon/><span className="span-bold">Company</span><span>: {companies?.find((c) => c.id === companyid)?.name || "—"}</span>
                   </label><br/>
                   <label>
                     <RoleIcon/><span className="span-bold">Role</span><span>: {roles?.find((c) => c) || "—"}</span>
                   </label>
                </div>
             </div>
          )}
        </div>
        {isOpen && (
        <div style={{position: "fixed",top: 0,left: 0,right: 0,bottom: 0,display: "flex",justifyContent: "center",alignItems: "center",zIndex: 1000,}}> 
            <div style={{backgroundColor: "white",borderRadius: "8px",width: "300px",boxShadow: "0 5px 15px rgba(0,0,0,0.3)",}}>
              <div style={{background:"rgb(236, 236, 236)"}}>
                <h2 style={{ margin:"0px",padding:"13px 0px" }}>Delete User</h2>
              </div>
              <div style={{border: "solid rgb(236, 236, 236) 1px", padding:"10px"}}>
                <p style={{ marginBottom: "20px" }}>Do you want to delete the user? <br/><br/>Note: The user will be deleted without the possibility of restoration.</p>
                <div className="submit-container" style={{padding:"0px 10px", margin: "20px 0px"}}>
                  <div className="cancel" style={{ height: "30px",borderRadius:"8px",fontSize:"16px" }} onClick={() => setIsOpen(false)}>Cancel</div>
                  <div className="submit" style={{ height: "30px",borderRadius:"8px",fontSize:"16px" }} onClick={() => okClick()}>Ok</div>
                </div>
              </div>
            </div>
        </div>
      )}
      </div>
    );
  }

  const loadStatisticSummary = useCallback(async () => {
    try {
      setLoading(true);
       const data = await infrastructureService.get("Statistic"); 
       setAvailableCompanies(data.availableCompanies);
       setAvailableDevices(data.availableDevices);
       setAvailableUsers(data.availableUsers);
       setAvailableEmailNotifications(data.emailNotifications);
       setAvailablemMssagesNotifications(data.smsNotifications);
       setAvailablePhoneCallsNotifications(data.phoneCallsNotifications);
    } catch (error) {
       console.error("Error fetching statistic summary:", error);
    } finally {
      setLoading(false);
    }
  }, [infrastructureService]);

  async function okClick() {
      setLoading(true);
      let user = {
          userId: selectedItemId
      };
      try {
         await infrastructureService.delete("User", user);
         AppAlert.success("User was deleted successfully");
      } catch (err) {
        if (err instanceof ApiError) {
          if (err.errors) {
            AppAlert.error(Object.values(err.errors).flat().join("\n"));
          } else if(err.status === 500){
            AppAlert.error("500 Internal Server Error");
          } else {
            AppAlert.error(err.message);
          }
        } else { 
          AppAlert.error("User deletion error");
        }
      } finally {
          setLoading(false);
      }
      setUsers([]);
      loadUsers();
      loadStatisticSummary();
      setIsOpen(false);
  }

  const companyOptions = [
    { value: "all", label: "Select all companies" },
    ...companies.map((c) => ({
      value: String(c.id), 
      label: c.name
    }))
  ];

const loadUsers = useCallback(async () => {
  try {
    setLoading(true);
    let getUsers = {
      filter: filter,
      fromIndex: (currentPage - 1) * itemsPerPage, 
      companyId: companyId,
      itemsCount: itemsPerPage
    };
    const data = await infrastructureService.get("Users", getUsers); 
    setUsers(data.items);
    setTotalPages(Math.ceil(data.totalItemsCount / itemsPerPage));
  } catch (error) {
    console.error("Error fetching users:", error);
  } finally {
    setLoading(false);
  }
}, [infrastructureService, filter, companyId, currentPage, itemsPerPage]);


  const loadCompanies = useCallback(async () => {
    try {
      setLoading(true);
      let getCompanies = {
        filter: "",
        showBlocked: false,
        fromIndex: 0,
        itemsCount: ""
      };
      const data = await infrastructureService.get("Companies", getCompanies); 
      setCompanies(data.items);
    } catch (error) {
       console.error("Error fetching companies:", error);
    } finally {
      setLoading(false);
    }
  }, [infrastructureService]);

  useEffect(() => {
    loadUsers();
  }, [loadUsers]);

  useEffect(() => {
    const newFilter = searchParams.get("filter") || "";
    const newCompanyId = searchParams.get("companyId") || "";
    const newCurrentPage = Number(searchParams.get("currentPage")) || 1;
    setFilter(newFilter);
    setCompanyId(newCompanyId);
    setCurrentPage(newCurrentPage);
  }, [searchParams]);

  useEffect(() => {
    loadCompanies();
    loadStatisticSummary();
  }, [loadCompanies, loadStatisticSummary]);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 600) {
        setOpen(true);
      } else {
        setOpen(false);
      }
    };
    
    handleResize();
    
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const getPages = () => {
    const pages = [];
    const delta = 1; 
  
    for (let i = 1; i <= Math.min(2, totalPages); i++) {
      pages.push(i);
    }
  
    const start = Math.max(currentPage - delta, 3);
    const end = Math.min(currentPage + delta, totalPages - 2);

    if (start > 3) pages.push("left-ellipsis");

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    if (end < totalPages - 2) pages.push("right-ellipsis");

    if (totalPages > 3) {
      for (let i = Math.max(totalPages - 1, end + 1); i <= totalPages; i++) {
        pages.push(i);
      }
    }

    return [...new Set(pages)]; 
  }

  return (
    <div>
      <div className="div-menu">
        <div onClick={() => setOpen(true)} className="menu-button">
          <label><svg width="30" height="30" fill="currentColor" viewBox="0 0 16 16">
            <path fillRule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 
                                         0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5"/>
          </svg></label>
        </div>
        {open && (
          <div className="modal">
             <div className="modal-content">
               <div className="col-span-12 h-full rounded-2xl bg-white/70 p-4 shadow-sm ring-1 ring-gray-100 md:col-span-3 lg:col-span-2 modal-content-div">
                <div className="close-modal" onClick={() => setOpen(false)}>
                  <MenuIcon/>
                </div>
                <div className="space-y-6">
                  <div>
                      <p className="px-2 text-sm font-semibold text-gray-600">Overview</p>
                      <div className="mt-2 space-y-1">
                         <Link className="link-item" to="/">
                           <label className="link-lab"> 
                              <CompaniesMenuIcon/> Companies
                              <label className="label-float-end">{availableCompanies}</label>
                           </label>
                         </Link>
                         <Link className="link-item-selected" to="/users">
                           <label className="link-lab">
                              <UsersMenuIcon/> Users
                              <label className="label-float-end">{availableUsers}</label>
                           </label>
                         </Link>
                         <Link className="link-item" to="/devices">
                           <label className="link-lab">
                               <DevicesMenuIcon/> Devices
                               <label className="label-float-end">{availableDevices}</label>
                           </label>
                         </Link>
                      </div>
                      <hr/>
                  </div>
                  
                   <div className="pt-2">
                        <p className="px-2 text-sm font-semibold text-gray-600">Notifications</p>
                        <div className="mt-2 space-y-1">
                         <Link className="link-item" to="/emails">
                           <label className="link-lab">
                              <EmailsMenuIcon/> Emails
                               <label className="label-float-end">{emailNotifications}</label>
                           </label>
                         </Link>
                         <Link className="link-item" to="/messages">
                           <label className="link-lab">
                              <MessagesMenuIcon/> Messages
                               <label className="label-float-end">{messagesNotifications}</label>
                           </label>
                         </Link>
                         <Link className="link-item" to="/phoneCalls">
                           <label className="link-lab">
                              <PhoneNumberMenuIcon/> Phone Calls
                               <label className="label-float-end">{phoneCallsNotifications}</label>
                           </label>
                         </Link>
                        </div>
                        <hr/>
                    </div>
                    
                  <div className="mx-2 h-px bg-gray-200"/></div>
                </div>
             </div>
          </div>
        )}
      </div>
       <div className='companies'>
        <div className='filter'>
             <div>
               <div className='div-input-filter-c'>
                <div className="group">
                  <svg className="icon" aria-hidden="true" viewBox="0 0 16 16">
                       <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 
                       1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"/>
                  </svg>
                  <input placeholder="Filter by keywords" type="search" className="input-filter" onChange={handleChange} onBlur={handleBlur} value={filter}/>
                </div>
               </div>
                <svg className="icon-add" aria-hidden="true" viewBox="0 0 16 16" onClick={() => navigateToUserSettingsClick("new")}>
                    <path d="M8 1a.5.5 0 0 1 .5.5V7.5H14a.5.5 0 0 1 0 1H8.5V14a.5.5 0 0 1-1 0V8.5H2a.5.5 0 0 1 0-1h5.5V1.5A.5.5 0 0 1 8 1Z" />
                </svg>
             </div>
             {userRole !== undefined && userRole === Global_Admin_Role && (<div className='div-input-checkbox-d'>
                <div className="select-company">
                  <Select options={companyOptions} isSearchable={true} placeholder="Please select a company" styles={customStyles}
                          value={companyOptions.find((opt) => opt.value === String(companyId)) || null} onChange={handleCompanyChange}/>
                </div>
             </div>)}
          </div>          

          {loading && (<div>Loading...</div>)}

          <div className="pagination-div pagination-div-margin">
                <nav aria-label="pagination">
                   <ul className="pagination">
                    <li>
                      <button disabled={currentPage === 1} onClick={() => handlePageChange(1)}
                          style={{padding: "5px 10px", borderRadius: "15px", border: "1px solid #ccc",
                                  color: "#333", fontWeight: "normal", backgroundColor: currentPage === 1 ? "#e6e6e6ff" : "white" }}>
                         &laquo;
                      </button>
                    </li>
                    {getPages().map((page, index) => page === "left-ellipsis" || page === "right-ellipsis" ? (
                        <li key={index}>…</li>) : (<li key={index}>
                          <button onClick={() => handlePageChange(page)}
                            style={{ margin: "0", padding: "5px 10px", borderRadius: "15px", border: "1px solid #ccc",
                                     backgroundColor: currentPage === page ? "#333" : "white", color: currentPage === page ? "white" : "#333", 
                                     fontWeight: currentPage === page ? "bold" : "normal", cursor: "pointer"}}>
                            {page}
                          </button>
                        </li>
                     ))}
                     <li>
                      <button disabled={currentPage === totalPages} onClick={() => handlePageChange(totalPages)}
                           style={{padding: "5px 10px", borderRadius: "15px", border: "1px solid #ccc",
                                   color: "#333", fontWeight: "normal", backgroundColor: currentPage === totalPages ? "#e6e6e6ff" : "white" }}>
                        &raquo;
                      </button>
                    </li>
                   </ul>
                </nav>
               </div>

         {!loading && (<div className="card-list" style={{minHeight:"500px"}}>
            {users != null && users.length > 0 ? (users.map((u) => (
              <User key={u.email} id={u.id} email={u.email} phoneNumber={u.phoneNumber} firstName={u.firstName} 
                    lastName={u.lastName} companyid={u.companyId} roles={u.roles}/>))) : (
              <p>No users available.</p>
            )}
         </div>)}

       </div>
    </div>
  )

}

export default Users;